<div class="filter-row">
  <div class="filter-left">
    <search-type typ="de" [current]="currentSearchType()" (update)="updateSearchType($event)"></search-type>
    <search-type typ="cn" [current]="currentSearchType()" (update)="updateSearchType($event)"></search-type>

    <fetch-cam-article-state [(state)]="data.article_state" (listener)="search()"></fetch-cam-article-state>

    <button class="btn btn-default btn-sm" type="button" (click)="badge('false', 'has_delivery_date', true)"
      [ngClass]="{active: q('false', 'has_delivery_date')}">
      Ohne Liefertermin <span class="badge"></span>
    </button>
  </div>
  <div class="filter-right">

    <date-range [start]="null" [end]="null" (update)="updateDateRange($event)" class="float-right"></date-range>

    <h3 class="align-special float-right">
      Lieferdatum:
    </h3>

    <div class="clear-both">&nbsp;</div>
  </div>
</div>

<form #changeForm="ngForm" name="form">
  <table class="table whitetable">
    <thead>
      <tr>
        <th>
          <a (click)="sort($event, 'task_list_id', 'ASC')" [href]="sortUrl('task_list_id', 'ASC')">
            Vorgang
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_workflow_fetch_status', 'ASC')"
            [href]="sortUrl('task_workflow_fetch_status', 'ASC')">
            Status
          </a>
        </th>
        <th>
          Abruf
        </th>
        <th>
          <a (click)="sort($event, 'task_workflow_fetch_position_quanity', 'DESC')"
            [href]="sortUrl('task_workflow_fetch_position_quanity', 'DESC')">
            Stückzahl
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_workflow_fetch_delivery', 'DESC_NULLS_LAST', 'ASC', 'DESC_NULLS_LAST')"
            [href]="sortUrl('task_workflow_fetch_delivery', 'DESC_NULLS_LAST', 'ASC', 'DESC_NULLS_LAST')">
            Lieferdatum
          </a>
        </th>
        <th>
          <a (click)="sort($event, 'task_list_sds_nr', 'ASC')" [href]="sortUrl('task_list_sds_nr', 'ASC')">
            SDS-Nr.
          </a>
        </th>
        <th>Artikel Ausführung</th>
        <th>Artikel Material</th>
        <th>Artikel Oberfläche</th>
        <th>
          <a (click)="sort($event, 'task_list_customer_name', 'ASC')"
            [href]="sortUrl('task_list_customer_name', 'ASC')">
            Kunde
          </a>
        </th>
        <th>
          Lagerbestand
        </th>
      </tr>
      <tr class="filterrow">
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.sid" name="sid" [autofocus] autocomplete="off search-fetch-id">
        </th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.quantity" name="quantity">
        </th>
        <th>
          <ev-datepicker [(ngModel)]="data.delivery_date" name="delivery_date" class="form-control input-sm"
            [allDates]="true">
          </ev-datepicker>
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.sds_nr" name="sds_nr">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.article_execution"
            name="article_execution">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.article_manufacturer"
            name="article_manufacturer">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.article_surface_area"
            name="article_surface_area">
        </th>
        <th>
          <input type="text" class="form-control input-sm" [(ngModel)]="data.customer_name" name="customer_name">
        </th>
        <th>
          &nbsp;
        </th>
      </tr>
    </thead>
    <tbody>
      @for (object of list.objects; track object; let index = $index) {
        <tr [ngClass]="object.css">
          <td>
            <a uiSref="a.workflow.detail" [uiParams]="{id: object.task.id}">
              @if (object.task.typ === 'cn') {
                <img src="/ui/assets/images/flags/cn.png">
              }
              @if (object.task.typ === 'de') {
                <img src="/ui/assets/images/flags/de.png">
              }
              {{ object.task.id }}
              @if (object.task.comments > 0) {
                <span class="td-comments" title="Kommentar(e) vorhanden">
                  <i class="fa fa-comments"></i>
                </span>
              }
              @if (object.task.kanban) {
                <span class="label label-danger">Kanban</span>
              }
            </a>
          </td>
          <td>
            <ev-status-label type="fetch_status" [state]="object.fetch.status"></ev-status-label>
            @if (object.task.express_service) {
              <i class="fa fa-exclamation-triangle"></i> EIL
            }
            @if (object.fix_date) {
              <i class="fa fa-exclamation-triangle"></i> FIX
            }
          </td>
          <td>{{ object.fetch.ordering }} von {{ object.task.fetches }}</td>
          <td>{{ object.position.quanity|money }}</td>
          <td>{{ object.fetch.delivery }}</td>
          <td>
            <strong>{{ object.task.sds_nr }}</strong>
            <workflow-article-state [articleState]="object.task.article_state_change"></workflow-article-state>
          </td>
          <td>{{object.task.article_execution}}</td>
          <td>{{object.task.article_manufacturer}}</td>
          <td>{{object.task.article_surface_area}}</td>
          <td>
            <a uiSref="a.crm.customer.detail" [uiParams]="{id:object.task.customer_id}" target="_blank">
              {{ object.task.customer_name }}
            </a>
          </td>
          <td>
            {{ object.inventory }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</form>

<ev-navigation [page]="list.page" [pages]="list.pages" [query]="query()" (goto)="goto($event)"></ev-navigation>
